import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { DraggablePortletListComponent } from './draggable-portlet-list.component';

@NgModule({
  declarations: [
    DraggablePortletListComponent,
  ],
  imports: [
    CommonModule,
    NzMenuModule,
    TranslateModule,
  ],
  exports: [
    DraggablePortletListComponent,
  ]
})
export class DraggablePortletListModule {
}
